import React from "react";
import { ActiveMatters } from "@design-system";

export const MyLiveMattersContainer = () => {
  return <ActiveMatters />;
};
